import flightFiltersTemplate from './filters/flight-filters.html';
import FlightFiltersController from './filters/flight-filters-controller';
import FlightsHeaderController from './controllers/flightsHeaderCtrl';

import templateMainFlights from './../base/templates/flights/tabs.tmpl.html';
import templateMainFlightsRoundtrip from './../base/templates/flights/roundtrip.tmpl.html';
import templateMainFlightsOneway from './../base/templates/flights/oneway.tmpl.html';
import templateMainFlightsMultitrip from './templates/multi.tmpl.html';
import templateMainFlightsResults from './../base/templates/flights/results.tmpl.html';
import templateMainFlightsResultsHeader from './../base/templates/flights/results_header.tmpl.html';
import templateMainFlightsResultsCarousel from './../base/templates/flights/results_carousel.tmpl.html';
import templateMainFlightsResultsFlights from './../base/templates/flights/results_flights.tmpl.html';
import templateMainFlightsResultsMulti from './templates/results_multi_flights.tmpl.html';
import templateMainFlightsResultsRules from './../base/templates/flights/rules.tmpl.html';
import FlightsListController from './controllers/flightsListCtrl';
import FlightsMultitripListController from './controllers/flights-multitrip-list-controller';
import FlightsRoundtripController from './controllers/flightsRoundtripCtrl';
import FlightsOnewayController from './controllers/flightsOnewayCtrl';
import FlightsMultitripController from './controllers/flightsMultitripCtrl';
import FlightResultsController from './controllers/FlightResultsCtrl';
import FlightsCarouselController from './controllers/flightsCarouselCtrl';
import UkrailResultsController from './controllers/ukrailResultsCtrl';
import RulesBaseController from '../../modules/base/controllers/flights/rulesBaseCtrl';


import FlightsSearchFormCtrl from './controllers/flightsSearchFormCtrl';
import templateMainUkrailResults from './../base/templates/flights/ukrail_results.tmpl.html';

export const flightStates = {
    MAIN: 'main.flights',
    ROUNDTRIP: 'main.flights.roundtrip',
    ONEWAY: 'main.flights.oneway',
    MULTI_TRIP: 'main.flights.multitrip',
    FLIGHTS_RESULTS: 'main.flights.results',
    FLIGHTS_MULTI_RESULTS: 'main.flights.results.multi',
    FLIGHTS_RESULTS_RULES: 'main.flights.results.rules',
};
export const MAX_MULTI_FLIGHTS_SEGMENTS = 8;
export const DEFAULT_MULTI_FLIGHTS_SEGMENTS = 2;
export const DEFAULT_CABIN_CLASS_INDEX = 1;

export default function FlightsRoutes(
    $stateProvider,
    $urlRouterProvider
) {
    'ngInject';

    $urlRouterProvider.when('/search/flights', '/search/flights/roundtrip');

    $stateProvider // eslint-disable-line
        .state(flightStates.MAIN, {
            url: '/flights',
            views: {
                '': {
                    template: templateMainFlights,
                    controller: FlightsSearchFormCtrl,
                    resolve: {
                        settingsCabinClasses: function($rootScope, staticDataGetter) {
                            'ngInject';
                            return $rootScope.readOnlyMode ? [] : staticDataGetter.getFlightsCabinClasses();
                        },
                        timeSlots: function(staticDataGetter) {
                            'ngInject';
                            return staticDataGetter.getTimeSlots();
                        },
                        fareTypesInited: function(flightFareService) {
                            'ngInject';
                            return flightFareService.getFareTypes();
                        },
                    },
                },
            },
            resolve: {
                flightsFactory: function(FtFactory) {
                    'ngInject';
                    return new FtFactory('flights');
                },
            },
            onEnter: function($rootScope) {
                'ngInject';
                $rootScope.pageHeading = 'Flights search';
            },
        })
        .state(flightStates.ROUNDTRIP, {
            url: '/roundtrip',
            template: templateMainFlightsRoundtrip,
            controller: FlightsRoundtripController,
        })
        .state(flightStates.ONEWAY, {
            url: '/oneway',
            template: templateMainFlightsOneway,
            controller: FlightsOnewayController,
        })
        .state(flightStates.MULTI_TRIP, {
            url: '/multitrip',
            template: templateMainFlightsMultitrip,
            controller: FlightsMultitripController,
            controllerAs: 'flightsMultitripCtrl',
        })

        .state(flightStates.FLIGHTS_RESULTS, {
            url: '/results',
            onExit: function($rootScope) {
                'ngInject';
                $rootScope.pageHeading = 'Flights search';
            },
            resolve: {
                previousState: function($state) {
                    'ngInject';
                    return {
                        name: $state.current.name,
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params),
                    };
                },
            },
            views: {
                '@main': {
                    template: templateMainFlightsResults,
                    controller: FlightResultsController,
                    controllerAs: 'flightResultsCtrl',
                },
                [`page_title@${flightStates.FLIGHTS_RESULTS}`]: {
                    template: templateMainFlightsResultsHeader,
                    controller: FlightsHeaderController,
                    controllerAs: 'flightsHeaderCtrl',
                },
                [`resultsFilters@${flightStates.FLIGHTS_RESULTS}`]: {
                    template: flightFiltersTemplate,
                    controller: FlightFiltersController,
                    controllerAs: 'flightFiltersCtrl',
                },
                [`resultsCarousel@${flightStates.FLIGHTS_RESULTS}`]: {
                    template: templateMainFlightsResultsCarousel,
                    controller: FlightsCarouselController,
                },
                [`resultsFlights@${flightStates.FLIGHTS_RESULTS}`]: {
                    template: templateMainFlightsResultsFlights,
                    controller: FlightsListController,
                },
                [`ukrailResults@${flightStates.FLIGHTS_RESULTS}`]: {
                    template: templateMainUkrailResults,
                    controller: UkrailResultsController,
                    $stateParams: {
                        IsRailSearchAvailable: false,
                        RailSearchId: '0',
                    },
                },
            },
        })

        .state(flightStates.FLIGHTS_MULTI_RESULTS, {
            url: '/multitrip',
            views: {
                'resultsFlights@main.flights.results': {
                    template: templateMainFlightsResultsMulti,
                    controller: FlightsMultitripListController,
                    controllerAs: 'flightsMultitripListCtrl',
                },
            },
        })

        .state(flightStates.FLIGHTS_RESULTS_RULES, {
            url: '/rules?fare&recommendation&adult&child&infant&search&groups&anchor&culture',
            params: {
                groups: {array: true},
            },
            resolve: {
                anchorLink: function($stateParams) {
                    'ngInject';
                    return $stateParams.anchor;
                },
                rules: function($stateParams, flightsFactory) {
                    'ngInject';
                    return flightsFactory.getRules({
                        searchId: $stateParams.search,
                        fareId: $stateParams.fare,
                        recommendationId: $stateParams.recommendation,
                        adultCount: $stateParams.adult,
                        childCount: $stateParams.child,
                        infantCount: $stateParams.infant,
                        flightGroups: $stateParams.groups,
                        culture: $stateParams.culture,
                    });
                },
            },
            views: {
                '@main': {
                    template: templateMainFlightsResultsRules,
                    controller: RulesBaseController,
                },
            },
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flights-routes.js